import { PremiumOnPlatformType } from '../../SignInManager'
import type { PlanType } from './metsikonPlanConfig'

export type MobilePremiumWarningPlatform =
  | PremiumOnPlatformType.android
  | PremiumOnPlatformType.ios

export function getPostPurchaseMobileWarningPlatform(
  planType: PlanType,
  userIsPremium?: boolean | null,
  userIsSuper?: boolean | null,
  userPremiumOnPlatform?: number | null,
): MobilePremiumWarningPlatform | null {
  if (planType !== 'super') return null
  if (!userIsPremium || userIsSuper) return null
  if (userPremiumOnPlatform === PremiumOnPlatformType.android) {
    return PremiumOnPlatformType.android
  }
  if (userPremiumOnPlatform === PremiumOnPlatformType.ios) {
    return PremiumOnPlatformType.ios
  }
  return null
}

export function runUpgradeCallback(
  callback?: (() => unknown | Promise<unknown>) | null,
): void {
  if (!callback) return
  let maybePromise: unknown
  try {
    maybePromise = callback()
  } catch (error) {
    console.error('Metsikon post-upgrade callback failed:', error)
    return
  }
  if (
    maybePromise != null &&
    typeof (maybePromise as Promise<unknown>).then === 'function'
  ) {
    void (maybePromise as Promise<unknown>).catch((error) => {
      console.error('Metsikon post-upgrade callback failed:', error)
    })
  }
}
